/* eslint-disable class-methods-use-this */
import _ from 'lodash';
import * as api from '../../../../utils/apiClient';
import { restructureTasksByExecutorResponseModel } from './restructuring';
import { restructurePaginationModel } from '../../../../common/restructuring';

class TasksPublicService {
  async getTaskToExecutorOfId(state, taskId) {
    const response = await api.get(
      `/tasks/public/tasks-to-executors/${taskId}`
    );
    const responseJson = await response.json();
    return {
      response: responseJson,
      destructData: _.keyBy(
        _.map([responseJson.data], item =>
          restructureTasksByExecutorResponseModel(state, item)
        ),
        'id'
      )
    };
  }

  async getTasksToExecutors(state, queryParams) {
    const response = await api.get('/tasks/public/tasks-to-executors', {
      ...queryParams
    });
    const responseJson = await response.json();
    if (!responseJson.success) {
      return {
        response: responseJson,
        destructData: null
      };
    }
    return {
      response: responseJson,
      destructData: {
        tasksById: _.keyBy(
          _.map(responseJson.data.items, item =>
            restructureTasksByExecutorResponseModel(state, item)
          ),
          'id'
        ),
        tasksIds: _.map(responseJson.data.items, item => item.id),
        pagination: restructurePaginationModel(
          _.get(responseJson, 'data._meta')
        )
      }
    };
  }

  async getTimeTargetInfo(taskId) {
    const response = await api.get(`/tasks/public/time-target-info/${taskId}`);
    const responseJson = await response.json();
    return responseJson;
  }
}

export default new TasksPublicService();



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/services/TasksPublicService/index.js